import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from './components/UserLogin.vue';
import QrList from './components/QrList.vue';
import EntryList from './components/EntryList.vue';


const routes = [
  { path: '/', component: UserLogin },
  { path: '/qr', component: QrList },
  { path: '/entries', component: EntryList },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
